import { colors } from '../../styles/colors';

/**
 * Modal de confirmation de suppression
 */
function DeleteChargeModal({ show, onClose, onConfirm, charge }) {
  if (!show || !charge) return null;

  const isGroup = charge.charges && charge.charges.length > 0;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        padding: '2rem',
        width: '90%',
        maxWidth: '400px'
      }}>
        <h2 style={{
          fontSize: '1.25rem',
          fontWeight: 'bold',
          color: colors.primary.gray,
          marginBottom: '1rem'
        }}>
          Confirmer la suppression
        </h2>
        <p style={{
          marginBottom: '1.5rem',
          color: colors.secondary.mediumGray
        }}>
          {isGroup
            ? `Êtes-vous sûr de vouloir supprimer toutes les ${charge.charges.length} charges du groupe "${charge.nom}" ?`
            : `Êtes-vous sûr de vouloir supprimer la charge "${charge.nom}" ?`
          }
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: colors.secondary.mediumGray,
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer',
              fontSize: '0.875rem'
            }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer',
              fontSize: '0.875rem'
            }}
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteChargeModal;
